import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/cms/v1/conversion`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const conversionApi = {
  getFacebookDataset: (params) => instance().get('/retrieve-facebook-dataset', { params }),
  postFacebookDataset: (data) => instance().post('/create-facebook-dataset', data),
  deleteFacebookDataset: (params, data) =>
    instance().delete('/disconnect-facebook-dataset', { params, data }),
  postUserEvent: (data) => instance().post('/save-user-event', data)
}

export default conversionApi



// WEBPACK FOOTER //
// ./src/api/conversion.js